import groupedRequestDetailsStore from "../store/store";
import { IndividualOpenShiftRequestDetails } from "../store/schema/GroupedRequestDetailsStoreSchema";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { ECSConfigKey, ECSConfigService } from "sh-services";

export default mutatorAction('UPDATE_OPEN_SHIFT_REQUEST_DETAILS_IN_STORE', function updateOpenShiftRequestDetailsInStore(requestDetailsList: IndividualOpenShiftRequestDetails[]) {
    if (groupedRequestDetailsStore && requestDetailsList) {
        if (!groupedRequestDetailsStore.individualRequestDetails) {
            groupedRequestDetailsStore.individualRequestDetails = new ObservableMap<string, IndividualOpenShiftRequestDetails>();
        }
        let allDeselected = true;

        requestDetailsList.forEach(requestDetails => {
            const shiftRequestId: string = requestDetails.request && requestDetails.request.id;
            if (shiftRequestId) {
                groupedRequestDetailsStore.individualRequestDetails.set(shiftRequestId, requestDetails);
                if (requestDetails.isSelected) {
                    allDeselected = false;
                }
            }
        });

        // ensure that the selectedRequestsCount is reset to 0 if all requests are deselected and selectedRequestsCount > 0
        if (groupedRequestDetailsStore.selectedRequestsCount > 0 && allDeselected) {
            groupedRequestDetailsStore.selectedRequestsCount = 0;
        }

        const isToggleCheckboxVisibilityEnabled = ECSConfigService.isECSFeatureEnabled(ECSConfigKey.ToggleCheckboxVisibilityEnabled);
        if (isToggleCheckboxVisibilityEnabled) {
            // if there is only one request in the group, select it by default
            if (groupedRequestDetailsStore.individualRequestDetails.size === 1 && !groupedRequestDetailsStore.isSaving) {
                const requestDetails = Array.from(groupedRequestDetailsStore.individualRequestDetails.values())[0];
                const requestDetailsRequestId: string = requestDetails.request && requestDetails.request.id;
                if (requestDetailsRequestId && !requestDetails.isSelected) {
                    groupedRequestDetailsStore.selectedRequestsCount = 1;
                    requestDetails.isSelected = !requestDetails.isSelected;
                    groupedRequestDetailsStore.individualRequestDetails.set(requestDetailsRequestId, requestDetails);
                }
            }
        }
    }
});